import React, { useState } from 'react';
import Button from '../../../../../../component/ui/Button';
import arrowForwardIcon from '../../../../../../assets/image/arrow-forward-icon.svg';

import NewCardModal from '../componets/newCardModal';
import SubscriptionBankCard from '../componets/subscriptionBankCard';
import ManageBillingTable from '../componets/manageBillingTable';

export default function ManageBilling({ setSubscriptionScreenType }) {
	const [isOpenCardModal, setIsOpenCardModal] = useState(false);
	const [params, setParams] = useState({
		label: 'Today',
		filter_by: 'today',
		start_date: null,
		end_date: null,
		total_pages: 12,
		page_size: 10,
		page: 1,
	});
	const columns = [
		{ label: 'DATE', key: 'date', align: 'left' },
		{ label: 'NAME', key: 'description', align: 'right' },
		{ label: 'AMOUNT', key: 'amount', align: 'right' },
		{ label: 'PAID VIA', key: 'cardNumber', align: 'right' },
		{ label: 'VIEW INVOICE', key: 'fileType', align: 'center' },
	];
	const [billingHistory, setBillingHistory] = useState([
		{
			date: 'April 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'March 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'February 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
		{
			date: 'January 5, 2026',
			description: 'Professional Plan Renewal',
			amount: 450.0,
			cardNumber: 'XXXX.....7584',
			fileType: 'pdf',
		},
	]);
	const [cardsList, setCardsList] = useState([
		{
			card_type: 'Debit Card',
			card_number: 'XXXX ..... 7584',
			expiry_date: '06/27',
			status: 'Active',
		},
		{
			card_type: 'Debit Card',
			card_number: 'XXXX ..... 7584',
			expiry_date: '06/27',
			status: 'Inactive',
		},
	]);
	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="d-flex justify-content-start align-items-center gap-3">
						<div
							className="fs-4 fw-semibold cursor-pointer"
							onClick={() => setSubscriptionScreenType('subscription')}
						>
							{'My Subscription'}
						</div>
						<img
							width={12}
							height={12}
							src={arrowForwardIcon}
							alt="arrow-icon"
						/>
						<div className="fs-4 fw-semibold">{'Manage Billing'}</div>
					</div>
					<div className="d-flex px-3">
						<Button
							type="button"
							className="mt-0 btn-danger fs-5 fw-light add-pro py-1"
							button=""
							close
							onClick={() => setSubscriptionScreenType('subscription')}
						/>
					</div>
				</div>
			</div>
			<div
				className="px-3 pt-3 pb-2"
				style={{ overflow: 'hidden' }}
			>
				<div className="d-flex align-items-center gap-5">
					<div className="fs-4 fw-bold py-2">Payment Method</div>
					<div
						style={{ color: 'blue', cursor: 'pointer', textDecorationLine: 'underline' }}
						onClick={() => {
							setIsOpenCardModal(true);
						}}
					>
						+ Add New
					</div>
				</div>
				<div className="row">
					{cardsList.length > 0 && cardsList.map((card) => <SubscriptionBankCard card={card} />)}
				</div>
				<ManageBillingTable
					params={params}
					setParams={setParams}
					tableColumns={columns}
					data={billingHistory}
				/>
			</div>
			{isOpenCardModal && (
				<NewCardModal
					isOpenModal={isOpenCardModal}
					setIsOpenModal={setIsOpenCardModal}
				/>
			)}
		</div>
	);
}
